<template>
  <div class="home">
    <!-- 头部标题 -->
    <van-nav-bar :title="title" @click-right="onClickRight">
      <template #right v-if="isMsgConfig">
        <van-icon name="chat-o" size="18" color="#fff" />
      </template>
    </van-nav-bar>
    <!-- 卡号区域 -->
    <Card>
      <template slot="card">
        <div class="cardArrangement">
          <div class="headTop">
            <span style="min-width: 48px">卡号</span>
            <input type="text" class="cardNum" v-model="msisdnNum" placeholder="请输入流量卡号" @input="msisdnNum = msisdnNum.replace(/[^\w\/]/gi, '')" :disabled="isDisable" />
          </div>
          <div class="headBottom">
            <van-button type="info" color="rgb(65,158,254)" plain size="mini" style="backgroundcolor: rgb(237, 245, 255)" @click="inquired">查询</van-button>
            <van-button type="info" color="rgb(255,155,2)" plain size="mini" style="backgroundcolor: rgb(255, 236, 206)" @click="topUp" :disabled="onDisplay">充值</van-button>
          </div>
        </div>
      </template>
    </Card>
    <!-- 免责声明 -->
    <div class="disclaimer" v-if="showValue">
      <h5>免责声明</h5>
      <p>如果控制设备在物联卡网络故障的情况下，可能导致经济损失或者人员危险的场景，本地应使用手动紧急停止，机械连锁等独立于远程控制的冗余安全功能。 由于运营商原因导致网络临时中断，物联卡平台会尽快联系运营商解决修复但不承担任何由此导致的经济损失，如有特殊要求，客户可自行选择其他运营商和平台。</p>
    </div>
    <!-- 查询区域 -->
    <Card v-if="isshow === 'Inquire'" class="requireTop">
      <template slot="card" style="margin-top: 10px">
        <table class="cardInquire">
          <tr class="row">
            <th>接入号</th>
            <th id="h-accessNum">{{ inquire.msisdn }}</th>
          </tr>
          <tr class="row">
            <th>ICCID卡号</th>
            <th>{{ inquire.iccid }}</th>
          </tr>
          <tr class="row">
            <th>运营商</th>
            <th>{{ inquire.operator }}</th>
          </tr>
          <tr class="row">
            <th>到期日期</th>
            <th>{{ inquire.dueDate }}</th>
          </tr>
          <tr class="row">
            <th>卡状态</th>
            <th>
              {{ inquire.workingCondition }}
              <div class="btn">
                <van-button type="info" size="mini" class="classRefresh" @click="eventRefresh">刷新</van-button>
                <van-button type="info" size="mini" class="classActivate" @click="eventActivate">激活</van-button>
              </div>
            </th>
          </tr>
          <tr class="row">
            <th>套餐总量</th>
            <th>{{ inquire.comboName }}</th>
          </tr>
          <tr class="row">
            <th>结余流量</th>
            <th>{{ inquire.totalGprs }}MB</th>
          </tr>
          <tr class="row">
            <th>实际用量</th>
            <th>{{ useGprs }}MB</th>
          </tr>
          <tr class="row">
            <th>余额</th>
            <th>{{ inquire.remainGprs }}MB</th>
          </tr>
          <tr class="row">
            <th>生命周期</th>
            <th>{{ inquire.lifeCycle }}</th>
          </tr>
          <tr class="row" v-show="inquire.preRecharge == '是'">
            <th>预充值套餐</th>
            <th>{{ inquire.preComboDesc }}</th>
          </tr>
          <tr class="row" v-show="inquire.preRecharge == '是'">
            <th>到账时间</th>
            <th>{{ inquire.accountDate }}</th>
          </tr>
        </table>
      </template>
    </Card>
    <van-button plain type="info" size="small" v-if="isshow === 'Inquire'" @click="inquiredDev" style="width: 93.7%; margin-left: 3.15%; border-radius: 10px; backgroundcolor: rgb(237, 245, 255); color: rgb(65, 158, 254)">获取以下信息</van-button>
    <Card v-if="isshow === 'Inquire' ">
      <template slot="card">
        <table class="cardInquire">
          <tr class="row">
            <th>IMSI</th>
            <th>{{ inquire.imsi }}</th>
          </tr>
          <tr class="row">
            <th>IMEI</th>
            <th>{{ devData.imei }}</th>
          </tr>
          <tr class="row">
            <th>冻结状态</th>
            <th>{{ inquire.freezeStatus }}</th>
          </tr>
          <tr class="row">
            <th>数据通信服务</th>
            <th>{{ devData.serviceStatus }}</th>
          </tr>
          <tr class="row">
            <th>开关机</th>
            <th>{{ devData.onOffStatus }}</th>
          </tr>
          <tr class="row">
            <th>apn状态</th>
            <th>{{ devData.apnStatus }}</th>
          </tr>
          <tr class="row">
            <th>在线状态</th>
            <th>{{ devData.onLineStatus }}</th>
          </tr>
        </table>
      </template>
    </Card>
    <Card v-if="isshow === 'disableView'">
      <template  slot="card">
        <div style="text-align: center;">
          请前往充值
        </div>
      </template>
    </Card>
    <!-- 充值区域 -->
    <Card v-else-if="isshow === 'Recharge'">
      <template slot="card">
        <div class="cardRecharge">
          <van-notice-bar v-show="isOwner == 0 ? false : true" color="#FE3C00" background="#FFF2EA" :left-icon="img"> 若原套餐未使用完，再次充值原套餐会清零！！！ </van-notice-bar>
          <div v-show="isOwner == 0 ? false : true">
            <span class="publicTitle">到账方式</span>
            <van-dropdown-menu :overlay="false" active-color="rgb(102,102,102)" style="min-width: 96px">
              <van-dropdown-item get-container="bidy" v-model="form.accountType" :options="option1" @change="accountTypechangefun" />
            </van-dropdown-menu>
          </div>
          <div v-if="isAccountType">
            <van-field readonly clickable name="datetimePicker" :value="form.accountDate" label="到账时间" placeholder="点击选择时间" @click="isAccountDate = true" label-width="72" style="padding-left: 0; margin-bottom: 10px" />
            <van-popup v-model="isAccountDate" round position="bottom" :style="{}">
              <van-datetime-picker type="year-month" title="选择年月" v-model="currentDate" :min-date="minDate" :max-date="maxDate" @confirm="onConfirm" @cancel="isAccountDate = false" />
            </van-popup>
          </div>
          <div>
            <XingbiaoButton :lister="xingList" :form="form" :msisdn="inquire.msisdn" :zfb="zfb" :wx="wx"></XingbiaoButton>
          </div>
          <div v-for="(item, index) in setMenu" :key="item.id">
            <span class="publicTitle">{{ item.title }}</span>
            <TrafficTopButton :lister="item.info" :form="form" :msisdn="inquire.msisdn" :zfb="zfb" :wx="wx"></TrafficTopButton>
          </div>
        </div>
      </template>
    </Card>
    <van-dialog v-model:show="ercodeshow" title="请使用微信扫一扫并输入144开头接入号进行缴费" :show-confirm-button="false" close-on-click-overlay>
      <img src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/mobile/images/ercode.jpg" style="width: 100%" />
    </van-dialog>
  </div>
</template>

<script>
import Card from '@/components/card'
import TrafficTopButton from '@/components/TrafficTopButton'
import XingbiaoButton from '@/components/XingbiaoButton'
import { Toast, Dialog } from 'vant'
import Clipboard from 'clipboard'
export default {
  data() {
    return {
      title: '流量在线充值系统',
      isshow: 0, //查询与充值的卡片切换
      msisdnNum: '', //用户输入的卡号
      inquire: {}, //卡号查询数据
      devData: {}, //设备信息
      uuid: '',
      showValue: false, //免责声明
      isMsgConfig: false, //是否显示短信
      /* 充值区域 */
      img: 'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/newIots/img/jg.png',
      form: {
        accountType: 1, //下拉框选中的选项
        accountDate: '' //到账时间
      },
      currentDate: new Date(new Date().getFullYear(), new Date().getMonth() + 1),
      isAccountType: false, //到账时间是否显示
      minDate: new Date(new Date().getFullYear(), new Date().getMonth() + 1),
      maxDate: new Date(new Date().getFullYear() + 5, new Date().getMonth()),
      isAccountDate: false, //到账时间弹窗
      option1: [
        { text: '即刻到账', value: 1 },
        { text: '预充值', value: 2 }
      ],
      setMenu: [], //充值卡片的套餐数据
      ercodeshow: false,
      zfb: '',
      wx: '',
      xingList: [],
      isshowchongzhi: false,
      isRecharge: 1, //是否充值（0是1否）
      isOwner: 1 //是否群组
    }
  },
  components: { Card, TrafficTopButton, XingbiaoButton },
  mounted() {
    let math = Math.random() * 10
    console.log(math.toFixed(0))

    this.$nextTick(() => {
      this.globel.imgs(this) // 请求图片
    })
    this.msisdnNum = this.$route.query.accessNum
    // this.msisdnNum = '14891519344'
    this.uuid = this.$route.query.id
    if (this.msisdnNum) {
      this.inquired()
    } else {
      this.isshow = 0
    }
  },
  computed: {
    useGprs() {
      let useGprs = (this.inquire.useGprs - this.inquire.chargeGprs).toFixed(2)
      return useGprs
    },
    onDisplay() {
      return this.isRecharge == 0 ? false : true
    },
    isDisable() {
      if (this.isshow == 'Recharge') {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    //全局获取数据
    getMessage(text) {
      this.globel.requestUrl('/cardInfo/queryCardInfoSelf', { msisdn: this.msisdnNum }).then(res => {
        Toast.clear()
        if (res.success == false) {
          this.isshow = 0
          return
        }
        this.globel.showSucces(text, 500)
        if (res.showValue == true) {
          this.showValue = res.showValue
        } else {
          this.showValue = false
        }
        this.$router.replace({ query: { accessNum: this.msisdnNum } }, () => {})
        this.isRecharge = res.isRecharge
        this.isOwner = res.isOwner
        this.inquire = res
        // this.getCanTopUpByuserId()
        this.queryStatus().then(status => {
          if (status) {
            this.findMsgConfig()
            this.isshow='Inquire'
          } else {
            this.isshow='disableView'
          }
        })
      })
    },
    queryStatus() {
      return new Promise((resolve, reject) => {
        this.globel.requestUrl('/peculiarConfig/queryStatus', { userId: this.inquire.userId, configType: 5 }).then(res => {
          resolve(res.status)
        })
      })
    },
    async getCanTopUpByuserId() {
      const { status } = await this.globel.requestUrl('/rechargeConfig/queryStatus', { userId: this.inquire.userId })
      this.isshowchongzhi = status
    },
    getdevMessage(text) {
      this.globel.requestUrl('/cardInfo/queryCardInfoDetailsByMsisdn', { msisdn: this.msisdnNum }).then(res => {
        Toast.clear()
        this.globel.showSucces(text, 500)
        this.devData = res
      })
    },
    //是否展示消息功能
    async findMsgConfig() {
      const { status } = await this.globel.requestUrl('/selfRacharge/findMsgConfig', { userId: this.inquire.userId })
      this.isMsgConfig = status
    },
    //查询
    inquired() {
      if (!this.globel.verify(this)) {
        return
      }
      this.globel.showLoading('查询中...')
      this.getMessage('查询成功')
      this.isAccountType = false
    },
    inquiredDev() {
      if (!this.globel.verify(this)) {
        return
      }
      this.globel.showLoading('查询中...')
      this.getdevMessage('查询成功')
    },
    // 充值套餐
    topUp(event) {
      if (!this.globel.verify(this)) {
        return
      }
      this.globel.showLoading('套餐查询中...')
      // if (this.isOwner == 1)      {
      this.globel.requestUrl('/combo/queryComboStar', { msisdn: this.msisdnNum, uuid: this.uuid }).then(resxing => {
        this.globel.requestUrl('/combo/queryComboSelf', { msisdn: this.msisdnNum, uuid: this.uuid }).then(res => {
          Toast.clear()
          if (res.success == false) {
            this.isshow = 0
            return
          }
          this.globel.showSucces('套餐查询成功', 500)
          this.isshow = 'Recharge'
          this.setMenu = res
          this.xingList = resxing
        })
      })
      // } else      {
      //   this.globel.requestUrl('/owner/queryComboSelf', { msisdn: this.msisdnNum }).then(res => {
      //     Toast.clear()
      //     if (res.success == false)          {
      //       this.isshow = 0
      //       return
      //     }
      //     this.globel.showSucces('套餐查询成功', 500)
      //     this.isshow = 'Recharge'
      //     this.setMenu = res
      //   })
      // }
    },
    //刷新卡状态
    eventRefresh() {
      Toast.loading({ message: '刷新中...', duration: 0 })
      this.globel.requestUrl('/cardInfo/refreshCardStatusSelf', { msisdn: this.inquire.msisdn }).then(res => {
        console.log(res)
        if (res.success === true) {
          this.getMessage('刷新成功')
        } else {
          return
        }
      })
    },
    // 激活卡
    eventActivate() {
      Dialog.confirm({
        message: '是否确认激活此卡',
        confirmButtonColor: '#409EFE'
      })
        .then(() => {
          Toast.loading({ message: '复机中...', duration: 0 })
          this.globel.requestUrl('/cardInfo/activateSelf', { msisdn: this.inquire.msisdn }).then(res => {
            Toast.clear()
            if (res.success === true) {
              this.getMessage('激活成功')
            } else {
              if (res.msg == '当前用户有欠费，余额为-1元，不能办理该业务') {
                // 跳转充值页面
                Dialog.confirm({
                  message: '激活失败，该卡号处于停机保号中需要缴纳停机保号费一元，是否前往缴费？',
                  confirmButtonColor: '#409EFE',
                  className: 'copyBtn'
                })
                  .then(() => {
                    let clipboard = new Clipboard('.copyBtn', {
                      target: function () {
                        return document.getElementById('h-accessNum')
                      }
                    })
                    clipboard.on('success', e => {
                      Toast.success({
                        message: '卡号已复制，跳转后直接粘贴即可！！！',
                        duration: 2000,
                        onClose: () => {
                          if (/MicroMessenger/.test(window.navigator.userAgent)) {
                            location.href = 'https://ec.iot.10086.cn/service/wx/access/charge' //跳转支付窗口
                          } else {
                            console.log(this.ercodeshow)
                            this.ercodeshow = true
                          }
                        }
                      })
                    })
                  })
                  .catch(() => {})
              }
            }
          })
        })
        .catch(err => {})
    },
    //充值方式改变方法
    accountTypechangefun(value) {
      if (value == 1) {
        this.form.accountDate = 1
        this.isAccountType = false
      } else if (value == 2) {
        this.form.accountDate = ''
        this.isAccountType = true
      }
    },
    //时间选择完成赋值
    onConfirm(datetime) {
      // console.log(datetime)
      let year = datetime.getFullYear()
      let month = datetime.getMonth() + 1
      month = month < 10 ? '0' + month : month
      let time = year + '-' + month
      this.form.accountDate = time
      this.isAccountDate = false
    },
    onClickRight() {
      const { msisdn, operator } = this.inquire
      // if (operator == '联通')      {
      //   // this.global.messagefun("fail", '联通尚未开通短信功能')
      //   return
      // }
      this.$router.push({ path: '/shortMessage', query: { msisdn, operator: operator == '移动' ? '1' : operator == '联通' ? '2' : '3' } }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>
<style lang="scss">
.van-nav-bar {
  width: 100%;
  background: url('https://xuyuweb.oss-cn-shanghai.aliyuncs.com/newIots/img/bjl.png') no-repeat 0px 0px;
  background-size: 100% 100%;
  .van-nav-bar__title {
    color: rgb(255, 255, 255);
  }
}
.cardArrangement {
  display: flex;
  flex-direction: column;
  font-size: 12px;
  .headTop {
    display: flex;
    align-items: center;
    span {
      font-size: 20px;
      font-weight: bold;
      color: rgb(102, 102, 102);
    }
    .cardNum {
      flex: 1;
      min-width: 133px;
      width: 30%;
      color: rgb(160, 160, 160);
      border: none;
      border-bottom: 1px gray solid;
      font-size: 16px;
      margin-left: 1%;
      padding-left: 5px;
    }
    .onDisplay {
      display: none;
    }
  }
  .headBottom {
    flex: 1;
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    .van-button {
      height: 32px;
      border-radius: 10px;
      width: 45%;
      height: 35px;
    }
    .van-button:nth-of-type(1) {
      background-color: rgb(236, 245, 255);
    }
    .van-button:nth-of-type(2) {
      background-color: rgb(255, 236, 206);
    }
  }
}

.cardInquire {
  width: 100%;
  color: rgb(106, 106, 106);
  .row {
    display: flex;
    height: 50px;
    @media screen and (max-width: 350px) {
      th {
        padding-left: 1%;
      }
    }
    @media screen and (min-width: 350px) {
      th {
        padding-left: 3%;
      }
    }
    th {
      border-top: 1px solid rgb(245, 245, 254);
      border-left: 1px solid rgb(245, 245, 254);
      text-align: left;
      display: flex;
      align-items: center;
      font-size: 15px;
    }
    th:nth-of-type(1) {
      flex: 1;
      min-width: 80px;
    }
    th:nth-of-type(2) {
      border-right: 1px solid rgb(245, 245, 254);
      flex: 2;
    }
    .btn {
      margin-left: 3%;
      flex: 1;
      display: flex;
      justify-content: space-evenly;
      .van-button {
        padding: 0px 10px;
        border-radius: 5px;
        border: none;
        min-width: 55px;
        width: 20%;
        height: 32px;
      }
      .classRefresh {
        background-color: #409efe;
      }
      .classActivate {
        background-color: #409efe;
        background-color: #ffb041;
      }
    }
  }
  .row:nth-of-type(2n-1) {
    background-color: rgb(247, 245, 250);
  }
  .row:last-of-type {
    border-bottom: 0.05rem solid rgb(245, 245, 254);
  }
}
@media screen and (max-width: 350px) {
  .row > th {
    padding-left: 1%;
  }
}
@media screen and (min-width: 350px) {
  .row > th {
    padding-left: 3%;
  }
}
.cardRecharge {
  color: rgb(102, 102, 102);
  .van-notice-bar {
    justify-content: center;
  }
  .publicTitle {
    font-size: 16px;
  }
  .van-dropdown-menu {
    width: 100px;
    height: 40px;
    margin: 10px 0 10px 20px;
    display: inline-block;
    position: relative;
    left: 0;
    top: 0;
    .van-dropdown-menu__bar {
      box-sizing: border-box;
      box-shadow: 0 0 0;
      height: 100%;
      border: 1px solid rgb(160, 160, 160);
      border-radius: 5px;
    }
    .van-dropdown-item {
      left: 3.15%;
    }
    .van-popup {
      position: absolute;
      left: 104px;
      width: 100px;
      min-width: 96px;
      border: 1px solid #8dc4ff;
      border-radius: 8px;
      .van-dropdown-item__option--active {
        background-color: #409efe;
        color: white !important;
      }
      .van-cell__value {
        display: none;
      }
    }
  }
}
.disclaimer {
  width: 93.7%;
  margin: auto;
  h5 {
    color: red;
    text-align: center;
    margin-bottom: 10px;
  }
  p {
    font-size: 12px;
    text-align: justify;
  }
}
.requireTop #card {
  margin-top: 0;
}
</style>
